module.exports = __webpack_public_path__ + "img/35.742ab5c0.png";